module.exports = __webpack_public_path__ + "static/media/Poppins-Regular-devanagari.790d0c8d.woff2";